import React from 'react'
import { Link, NavLink } from 'react-router-dom'

export default function Footer() {
  return (
    <div>
    <div className='flex-col md:flex-row lg:flex items-center md:items-start  m-auto justify-center space-y-28 md:space-y-0 lg:space-x-28 items-start text-center bg footer mt-28 py-24 md:py-16 lg:py-8'>


    <div className=' flex-col'>
    <h1 className='text-white'>LEADING DANSE</h1>
      <img src="../../img/logoBlanc.png" alt="Logo Leading Danse" className='m-auto' />
</div>

      <nav className='text-white text-center p-0'>
          <div className='flex-col  list-none m-auto text-center justify-center items-center space-y-4 text-white  '>
              

  
      <h1>Liens utiles</h1>


              <NavLink to="/" className="underline-hover ">Acceuil</NavLink> <br />
              <NavLink to="/a_propos" className="underline-hover ">À propos</NavLink> <br />
              <NavLink to="/prestations" className="underline-hover ">Prestations</NavLink> <br />
              <NavLink to="/lady_style" className="underline-hover ">Lady Style</NavLink> <br />
              <NavLink to="/informations" className="underline-hover ">Informations</NavLink><br />
          </div>
      </nav>
   


      <div className='fixed   text-amber-500 md:right-16 md:bottom-16 right-4 bottom-4'>
              <a  href="#top">
                  <img className='text-center w-1/28 py-4 m-auto ' src="../../img/top.png"  alt=""  id="top"/>
              </a>
      </div>

     

  </div>
  <div className='bg'>
   <p id="footA" className='text-center text-white m-auto bg pt-12' >
   Site créé par <a href="https://astra-lux.fr" alt=""><h1 id="footT">Astra Lux</h1></a><br />Tous droits réservés. <br />
 </p>
   <p id="tar" className='text-center w-4/6 m-auto'>Ce travail est protégé par la <a href="https://creativecommons.org/licenses/by-nd/4.0/" target="_blank" rel="license">licence Creative Commons Attribution - Pas de Modification 4.0 International</a>.</p>
   </div>
 </div>
  )
}
